import React from 'react';

const IncludeOnePerson = () => {
  return (
    <div className="vbz-icon-beneficiaries" data-testid="test-include-one-icon">
      <div className="vbz-icon-beneficiaries-include-one" />
    </div>
  );
};

export default IncludeOnePerson;
